import { GenericObject } from '@app/components/common/Table/DefaultTable/types';

import { transformApiDrivenInput } from './transformUtils';
import { FIELD_TYPES } from './validateUtils';

export const QUESTION_TYPE = {
  SINGLE_SELECT: 'SINGLE_SELECT',
  FREE_TEXT: 'FREE_TEXT',
  MULTIPLE_SELECT: 'MULTIPLE_SELECT',
};

export const formFields = [
  { key: 'question', type: FIELD_TYPES.MULTILINGUAL, message: 'Question is required' },
  { key: 'type', type: FIELD_TYPES.SELECT, message: 'Question Type is required' },
];

export const conditionalFields = [
  {
    key: 'responses',
    type: FIELD_TYPES.MULTILINGUAL_ARRAY,
    message: 'Responses are required',
    shouldValidate: (values: GenericObject) =>
      values.type === QUESTION_TYPE.SINGLE_SELECT || values.type === QUESTION_TYPE.MULTIPLE_SELECT,
  },
];

export const nonRequiredFields = [{ key: 'description', emptyValue: '', isMultilingual: true }];

export const getTypeLabel = (row: GenericObject) => {
  if (row?.type === QUESTION_TYPE.FREE_TEXT) {
    return 'Free Text';
  } else if (row?.type === QUESTION_TYPE.SINGLE_SELECT) {
    return 'Single';
  } else if (row?.type === QUESTION_TYPE.MULTIPLE_SELECT) {
    return 'Multiple';
  } else {
    return '';
  }
};

export const transformQuestionWithCallback = (
  values: GenericObject,
  additionalTransformCallback: Function,
  language: string
) => {
  const v = additionalTransformCallback(values);
  // FREE_TEXT payload should not have responses
  if (v.type === QUESTION_TYPE.FREE_TEXT && v.responses) {
    // @ts-ignore
    v.responses[language] = '';
  }
  return transformApiDrivenInput(v, 'responses', language);
};
